import { useState } from "react";
import { X } from "lucide-react";

const PRIVACY_TEXT = [
  {
    title: "1. Titolare del trattamento",
    body: "Il titolare del trattamento dei dati personali è Clario srl (di seguito \"Clario\"), contattabile all'indirizzo email info.clario@gmail.com.",
  },
  {
    title: "2. Dati raccolti",
    body: "Tramite il modulo di richiesta preventivo raccogliamo: nome e cognome, indirizzo email, numero di telefono, città/regione, tipologia di servizio richiesto e il contenuto del messaggio libero. Non raccogliamo categorie particolari di dati personali.",
  },
  {
    title: "3. Finalità e base giuridica",
    body: "I dati sono trattati esclusivamente per: (a) rispondere alla richiesta di preventivo e ricontattare l'interessato; (b) gestire l'eventuale successivo rapporto contrattuale. La base giuridica è l'esecuzione di misure precontrattuali adottate su richiesta dell'interessato (art. 6, par. 1, lett. b GDPR).",
  },
  {
    title: "4. Modalità del trattamento e conservazione",
    body: "Il trattamento avviene con strumenti informatici, nel rispetto delle misure di sicurezza previste dall'art. 32 GDPR. I dati delle richieste di preventivo sono conservati per un massimo di 24 mesi, salvo instaurazione di un rapporto contrattuale.",
  },
  {
    title: "5. Comunicazione a terzi",
    body: "I dati non sono venduti né ceduti a terzi. Possono essere trattati da fornitori tecnici (hosting, invio email) nominati responsabili del trattamento ai sensi dell'art. 28 GDPR.",
  },
  {
    title: "6. Diritti dell'interessato",
    body: "In qualsiasi momento puoi esercitare i diritti di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità (artt. 15-22 GDPR) scrivendo a info.clario@gmail.com. Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
  },
];

const COOKIE_TEXT = [
  {
    title: "1. Cosa sono i cookie",
    body: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi allo stesso sito alla visita successiva.",
  },
  {
    title: "2. Cookie utilizzati da questo sito",
    body: "Questo sito utilizza esclusivamente cookie tecnici e strumenti di memorizzazione locale strettamente necessari al funzionamento del servizio (ad esempio il salvataggio locale delle richieste di preventivo). Non utilizziamo cookie di profilazione, cookie pubblicitari né cookie di terze parti a fini di marketing.",
  },
  {
    title: "3. Consenso",
    body: "Per i soli cookie tecnici non è richiesto il consenso preventivo dell'utente, ai sensi del provvedimento del Garante privacy e delle Linee guida cookie del 10 giugno 2021.",
  },
  {
    title: "4. Come disabilitare i cookie",
    body: "Puoi gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser. La disabilitazione dei cookie tecnici potrebbe compromettere il corretto funzionamento di alcune parti del sito.",
  },
  {
    title: "5. Contatti",
    body: "Per qualsiasi domanda relativa alla presente cookie policy puoi scrivere a info.clario@gmail.com.",
  },
];

export const PolicyModal = ({ open, onClose }) => {
  if (!open) return null;
  const sections = open === "privacy" ? PRIVACY_TEXT : COOKIE_TEXT;
  const title = open === "privacy" ? "Informativa Privacy" : "Cookie Policy";

  return (
    <div
      data-testid="policy-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0F172A]/60 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative max-h-[85vh] w-full max-w-2xl overflow-hidden rounded-[1.5rem] bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-6 py-5 sm:px-8">
          <h3 className="text-xl font-bold tracking-tight text-slate-900">{title}</h3>
          <button
            data-testid="policy-modal-close"
            onClick={onClose}
            aria-label="Chiudi"
            className="rounded-full p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="max-h-[calc(85vh-76px)] overflow-y-auto px-6 py-6 sm:px-8">
          <p className="mb-5 text-xs font-semibold uppercase tracking-wider text-slate-400">
            Ultimo aggiornamento: ottobre 2026
          </p>
          {sections.map((s) => (
            <div key={s.title} className="mb-5">
              <h4 className="text-sm font-bold text-slate-900">{s.title}</h4>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
